var React = require('react');

function Loader5 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1_343)","key":0},[React.createElement("rect",{"width":"90","height":"12","fill":"white","key":0}),React.createElement("rect",{"y":"24.5","width":"90","height":"12","fill":"white","key":1}),React.createElement("rect",{"y":"49","width":"90","height":"12","fill":"white","key":2}),React.createElement("rect",{"y":"73.5","width":"90","height":"12","fill":"white","key":3}),React.createElement("rect",{"y":"98","width":"90","height":"12","fill":"white","key":4})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1_343"},React.createElement("rect",{"width":"90","height":"110","fill":"white"})))]);
}

Loader5.defaultProps = {"width":"90","height":"110","viewBox":"0 0 90 110","fill":"none"};

module.exports = Loader5;

Loader5.default = Loader5;
